import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useContentLogic } from './useContentLogic';

import {
  FLIGHTS_RESERVE,
  FLIGHTS_SEARCH,
  PAYMENTS_FLIGHTS,
} from '@shared/helpers/routes';
import GenericBookingLayout from '@shared/components/GenericBookingLayout';
import DetailsComponent from './DetailsComponent';
import ModalChangedPNR from './ModalChangedPNR/ModalChangedPNR';
import {
  ConfirmDialogModal,
  CustomDialogModal,
} from '@shared/components/Dialogs';

const LayoutPaymentGateway = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const unlisten = history.listen((nextLocation, action) => {
      if (action === 'POP') {
        const goesBackToSearch =
          location.pathname === FLIGHTS_RESERVE &&
          nextLocation.pathname === FLIGHTS_SEARCH;

        const goesBackToReserve =
          location.pathname === PAYMENTS_FLIGHTS &&
          nextLocation.pathname === FLIGHTS_RESERVE;

        if (goesBackToSearch || goesBackToReserve) {
          history.replace({
            ...nextLocation,
            state: { ...(nextLocation.state || {}), refetch: true },
          });
        }
      }
    });

    return () => {
      unlisten();
    };
  }, [history, location.pathname, location.state]);

  const {
    isPayment,
    showModal,
    setShowModal,
    openModalChangedPNR,
    setOpenModalChangedPNR,
    state,
    flightValidate,
    infoFlightsSearch,
    flightsInUSD,
    cardData,
    steps,
    stepsWrapperComponent,
    formComponent,
    handleCancel,
    navegateNext,
    isBuy,
  } = useContentLogic(children);

  return (
    <>
      <GenericBookingLayout
        steps={steps}
        storageKey={location.state.storageKey}
        searchPath={FLIGHTS_SEARCH}
        pago={isPayment}
        operationType={isBuy ? 'compra' : 'reserva'}
        stepsWrapperComponent={stepsWrapperComponent}
        formComponent={formComponent}
        detailsComponent={
          <DetailsComponent
            infoFlightsSearch={infoFlightsSearch}
            flightValidate={flightValidate}
            flightsInUSD={flightsInUSD}
            isPayment={isPayment}
            cardData={cardData}
          />
        }
      />
      <ConfirmDialogModal
        isOpen={showModal}
        onCancel={() => {
          setShowModal(false);
        }}
        onConfirm={() => {
          history.push(FLIGHTS_SEARCH, { refetch: true });
          setShowModal(false);
        }}
        showVolver={true}
        text="Este vuelo no se encuentra disponible. Por favor seleccione otra opción."
      />
      {state && (
        <CustomDialogModal
          open={openModalChangedPNR}
          onClose={() => setOpenModalChangedPNR(false)}
          fullWidth
          sxDialog={{
            '& .MuiDialog-paper': {
              maxWidth: { xs: '320px', sm: '420px', md: '800px', lg: '1100px' },
              width: '100%',
              p: { xs: 1, sm: 2, md: 3 },
            },
          }}
        >
          <ModalChangedPNR
            closeModal={() => setOpenModalChangedPNR(false)}
            state={state}
            isInUSD={flightsInUSD.isInUSD}
            handleConfirm={navegateNext}
            handleCancel={handleCancel}
          />
        </CustomDialogModal>
      )}
    </>
  );
};

export default LayoutPaymentGateway;
